import { alpha, Box, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(({ spacing, palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: 16,
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    gridGap: 20,
  },

  column: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: 8,
  },

  largeColumn: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: 16,
  },

  backgroundAvatar: ({ dense }: Props) => ({
    position: 'relative',
    width: dense ? spacing(8) : spacing(12.5),
    height: dense ? spacing(8) : spacing(12.5),
    backgroundColor: alpha(palette.primary.main, 0.2),
    borderRadius: spacing(1),
    borderTopRightRadius: spacing(2),
    borderBottomRightRadius: spacing(2),
    marginRight: spacing(5),
  }),
  avatarBadge: ({ dense }: Props) => ({
    position: 'absolute',
    top: 0,
    right: dense ? -25 : -35,
  }),
  avatarLarge: ({ dense }: Props) => ({
    width: dense ? spacing(8) : spacing(12.5),
    height: dense ? spacing(8) : spacing(12.5),
    border: `2px solid ${alpha(palette.primary.main, 0.3)}`,
    borderRadius: 99,
    backgroundColor: palette.background.tertiary,
  }),

  skeletonBox: {
    borderRadius: 8,
  },

  radius4: {
    borderRadius: 4,
  },
}));

// Componente utilitário
function SkeletonBox({
  classes,
  height,
  width = '100%',
  radius = 8,
}: {
  classes: ReturnType<typeof useStyles>;
  height: number;
  width?: string;
  radius?: number;
}) {
  return (
    <Skeleton
      animation="wave"
      variant="rect"
      height={height}
      width={width}
      className={radius === 8 ? classes.skeletonBox : classes.radius4}
    />
  );
}

interface Props {
  dense?: boolean;
}

export default function DrawerDetalhesContatoSkeleton({ dense }: Props) {
  const classes = useStyles({ dense });

  return (
    <Box className={classes.container}>
      <Box className={classes.row}>
        <Box className={classes.backgroundAvatar}>
          <Box className={classes.avatarBadge}>
            <Skeleton
              animation="wave"
              variant="circle"
              className={classes.avatarLarge}
            />
          </Box>
        </Box>

        <SkeletonBox classes={classes} height={65} />
      </Box>

      <Box className={classes.column}>
        <SkeletonBox classes={classes} height={24} width="50%" />
        <SkeletonBox classes={classes} height={24} width="50%" />
      </Box>

      <Box className={classes.row} style={{ gridGap: 8 }}>
        <SkeletonBox classes={classes} height={40} />
        <SkeletonBox classes={classes} height={40} />
        <SkeletonBox classes={classes} height={40} />
      </Box>

      <Box>
        <SkeletonBox classes={classes} height={120} />
      </Box>

      <Box className={classes.largeColumn}>
        <SkeletonBox classes={classes} height={20} width="50%" radius={4} />

        <Box className={classes.largeColumn}>
          <SkeletonBox classes={classes} height={55} />
          <SkeletonBox classes={classes} height={55} />
          <SkeletonBox classes={classes} height={55} />
          <SkeletonBox classes={classes} height={55} />
          <SkeletonBox classes={classes} height={55} />
        </Box>
      </Box>
    </Box>
  );
}
